import cn from 'classnames';
import styles from "./ProgressBar.module.scss";
import { pathgen } from 'object-path-generator';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressBarTestIds = pathgen('ProgressBarTestIds');
export const ProgressBar = props => {
  const {
    completed,
    total,
    variant = 'steps',
    'data-testid': testId,
    className
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.progressBar, styles[variant + 'Variant'], className),
    "data-testid": testId || ProgressBarTestIds.root(),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.progressThumb,
      style: {
        width: 100 * completed / total + '%'
      },
      "data-total": total,
      "data-completed": completed,
      "data-testid": ProgressBarTestIds.thumb()
    })
  });
};